// extracted by mini-css-extract-plugin
export default {"ul-search":"ULSearch_ul-search__S3XjZ","clear-button":"ULSearch_clear-button__3zrE8"};